import http from './httpService';
import config from '../components/common/config';

export function getNewsListing() {
  return http.get(config.newsEndpoint);
}
